import * as Business      from '../../business';
import * as UI            from '../../ui';
import { compose }        from 'redux';
import { connect }        from 'react-redux';
import { Fragment }       from 'react';
import ChooseLocationView from './choose_location_view';
import FetchFromServer    from '../../components/fetch_from_server';
import Navbar             from '../../components/navbar';
import React              from 'react';


export default connect(
  (state, { businessID }) => ({
    business: Business.getBusiness(state, businessID),
    statuses: Business.getBusinessStatuses(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load:               compose(dispatch, Business.loadBusiness, () => (businessID)),
    saveGoogleLocation: compose(dispatch, Business.saveGoogleLocation, locationInfo => ({ businessID, locationInfo })),
    progressStart:      () => dispatch(UI.progressStart()),
    progressEnd:        () => dispatch(UI.progressEnd())
  })
)(GmbConnectPage);


export function GmbConnectPage({
  businessID,
  business,
  statuses,
  load,
  saveGoogleLocation,
  navigateTo,
  navigateBackTo,
  progressStart,
  progressEnd
}) {

  const { readStatus } = statuses;
  const isReady        = readStatus.succeeded;

  return (
    <Fragment>
      <Navbar title="Google"/>
      <FetchFromServer statuses={statuses} load={load} className="settings business-profile google">

        {isReady &&
          <ChooseLocationView {...{
            businessID,
            business,
            statuses,
            saveGoogleLocation,
            navigateTo,
            navigateBackTo,
            progressStart,
            progressEnd
          }}/>
        }

      </FetchFromServer>
    </Fragment>
  );
}
